import script from "./Why.vue?vue&type=script&setup=true&lang=js"
export * from "./Why.vue?vue&type=script&setup=true&lang=js"

import "./Why.vue?vue&type=style&index=0&id=5cb8e98f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb8e98f"]])

export default __exports__